import axiosInstance from '@utils/axiosInstance';
import * as wjcInput from '@grapecity/wijmo.input';
import { FlexGridXlsxConverter } from '@grapecity/wijmo.grid.xlsx';
import { CellType } from '@grapecity/wijmo.grid';
import Swal from 'sweetalert2';

export async function clearUserInfo(dispatch) {

    const companyCode = localStorage.getItem("companyCode");
    const userInfo = localStorage.getItem("userInfo");
    const token = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).token : null;

    if (token) {

        try {
            const response = await axiosInstance.post('/api/auth/logout', null, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })

            if (response.status === 204) {
                // 로컬 스토리지에서 필요한 항목 제거
                if (companyCode) localStorage.removeItem("companyCode");
                if (userInfo) localStorage.removeItem("userInfo");
                window.location.href = '/';
            }

        } catch (error) {
            console.log(error);
        }

    }

}

export function formatDate(date) {

    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, "0");
    const d = date.getDate().toString().padStart(2, "0");
    return `${y}-${m}-${d}`;

}

export function formatDateTime(date) {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, "0");
    const d = date.getDate().toString().padStart(2, "0");
    const hh = date.getHours().toString().padStart(2, "0");
    const mm = date.getMinutes().toString().padStart(2, "0");
    const ss = date.getSeconds().toString().padStart(2, "0");

    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
}

export function getYearAndMonth() {
    var dateStart = new Date();
    var year = dateStart.getFullYear();
    var month = (dateStart.getMonth() + 1).toString().padStart(2, '0');
    var formattedDate = `${year}-${month}`;

    return formattedDate;
}

export function createFileContextMenu(owner, uploadFunc, viewFunc, downloadFunc, deleteFunc) {
    if (!owner?.hostElement) return;

    const itemsSource = [
        { header: '파일 업로드', cmd: 'upload' },
        { header: '-' },
        { header: '파일 미리보기', cmd: 'view' },
        { header: '-' },
        { header: '파일 다운로드', cmd: 'download' },
        { header: '-' },
        { header: '파일 삭제', cmd: 'delete' },
    ];

    const menu = new wjcInput.Menu(document.createElement('div'), {
        owner,
        displayMemberPath: 'header',
        commandParameterPath: 'cmd',
        closeOnLeave: true,
        itemsSource,
            command: {
                canExecuteCommand: (cmd) => {

                    var binding = owner.columns[owner.selection.col].binding
                    var rowNum = owner.selection.row

                    switch (cmd) {
                        case 'upload':
                            return true; 
                        case 'view':
                            return owner.rows[rowNum].dataItem[binding] === true;
                        case 'download':
                            return owner.rows[rowNum].dataItem[binding] === true;
                        case 'delete':
                            return owner.rows[rowNum].dataItem[binding] === true;
                    }
                    return true;
                },
            executeCommand: (cmd) => {
                switch (cmd) {
                    case 'upload':
                        uploadFunc();
                        break;
                    case 'view':
                        viewFunc();
                        break;
                    case 'download':
                        downloadFunc();
                        break;
                    case 'delete':
                        deleteFunc();
                        break;
                }
                
            }
        },
    });

    return menu;

}

export function createContextMenu(owner, activeTab, customItems = [], autoRegister = false) {
    if (!owner?.hostElement) return;

    const getExportExcelFileName = () => {
        const date = new Date();
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        const hh = String(date.getHours()).padStart(2, "0");
        const mm = String(date.getMinutes()).padStart(2, "0");
        const ss = String(date.getSeconds()).padStart(2, "0");
        return `${activeTab}_${y}${m}${d}_${hh}${mm}${ss}`;
    };

    const itemsSource = [
        { header: 'Excel 내보내기', cmd: 'export_excel' },
        ...customItems.flatMap(({ header, cmd }) => [
            { header: '-' },
            { header, cmd },
        ]),
    ];

    const menu = new wjcInput.Menu(document.createElement('div'), {
        owner,
        displayMemberPath: 'header',
        commandParameterPath: 'cmd',
        closeOnLeave: true,
        itemsSource,
        command: {
            canExecuteCommand: (cmd) => {
                const item = customItems.find((item) => item.cmd === cmd);
                return item ? item.condition() : true;
            },
            executeCommand: (cmd) => {
                if (cmd === 'export_excel') {
                    Swal.fire({
                        html: '엑셀로 내보내시겠습니까?',
                        icon: 'info',
                        confirmButtonText: '확인',
                        confirmButtonColor: '#3085d6',
                        showDenyButton: true,
                        denyButtonText: '취소',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((re) => {
                        if (re.isConfirmed) {
                            FlexGridXlsxConverter.saveAsync(
                                owner,
                                { includeColumnHeaders: true },
                                getExportExcelFileName()
                            );
                        }
                    });
                } else {
                    const item = customItems.find((item) => item.cmd === cmd);
                    item && item.callback();
                }
            },
        },
    });

    if (autoRegister) {

        const contextMenuHandler = (e) => {
            const sel = owner.selection;
            const ht = owner.hitTest(e);

            if (ht.cellType === CellType.Cell) {

                switch (ht.panel) {
                case owner.cells:
                    owner.select(ht.row, ht.col);
                    break;
                case owner.columnHeaders:
                    owner.select(sel.row, ht.col);
                    break;
                case owner.rowHeaders:
                    owner.select(ht.row, sel.col);
                    break;
                default:
                    return;
            }

            if (sel.col > -1) {
                e.preventDefault();
                menu.show(e);
            }

            }

        };

        owner.hostElement.addEventListener('contextmenu', contextMenuHandler);

    }

    return menu;

}

export function commonSaveValidation(grid, validationBindingList) {
    const items = grid.itemsSource;

    for (let i = 0; i < items.length; i++) {
        const item = items[i];

        for (const binding of validationBindingList) {
            if (!item[binding]) {
                const { header } = grid.columns.find(col => col.binding === binding);

                Swal.fire({
                    html: `${i + 1}행의 ${header}이(가) 입력되지 않았습니다.`,
                    icon: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didClose: () => {
                        grid.select(i, binding);
                        grid.startEditing();
                    }
                });

                return false;
            }
        }
    }

    return true;
}